import React from "react";
import "../../../AllComponentCSS.css";
import entities from "./EntitiesTopic";

export default function CSS_ReferenceEntittes() {
  const sectionStyle = {
    padding: "1rem",
    paddingLeft: "35px",
    borderRadius: "12px",
    marginBottom: "2rem",
  };

  return (
    <div className="tutorial-container">
      <h1 className="tutorial-title">💠 CSS Entities</h1>
      <p className="tutorial-intro">
        CSS supports Unicode characters and entities, which can be represented
        using their hexadecimal or named entity forms.
      </p>

      <div
        style={{
          ...sectionStyle,
          background: "linear-gradient(90deg, #fce7f3, #fbcfe8)",
          color: "#4a044e",
          overflowX: "auto",
        }}
      >
        <h2>🔡 Common CSS Character Entities</h2>
        <div style={{ overflowX: "auto" }}>
          <table
            className="tutorial-table"
            style={{
              width: "100%",
              borderCollapse: "collapse",
              borderRadius: "12px",
              overflow: "hidden",
              boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
            }}
          >
            <thead>
              <tr
                style={{
                  backgroundColor: "#be185d",
                  color: "#ffffff",
                  textAlign: "left",
                }}
              >
                <th style={{ padding: "12px" }}>Char</th>
                <th style={{ padding: "12px" }}>CSS Entity (Hex)</th>
                <th style={{ padding: "12px" }}>Name</th>
              </tr>
            </thead>
            <tbody>
              {entities.map((item, index) => (
                <tr
                  key={index}
                  style={{
                    backgroundColor: index % 2 === 0 ? "#fbcfe8" : "#fce7f3",
                    transition: "background-color 0.3s ease",
                  }}
                  onMouseEnter={(e) =>
                    (e.currentTarget.style.backgroundColor = "#f9a8d4")
                  }
                  onMouseLeave={(e) =>
                    (e.currentTarget.style.backgroundColor =
                      index % 2 === 0 ? "#fbcfe8" : "#fce7f3")
                  }
                >
                  <td style={{ padding: "10px", fontWeight: "bold" }}>
                    {item[0]}
                  </td>
                  <td style={{ padding: "10px" }}>{item[1]}</td>
                  <td style={{ padding: "10px" }}>{item[2]}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
